<template>
  <v-row class="mt-10" no-gutters>
    <v-col class="text-left">
      <v-btn
        color="default"
        elevation="0"
        v-if="onboardingStepsNavigation >= 2"
        @click="setOnboardingStepsNavigation(onboardingStepsNavigation - 1)"
      >
        Anterior
      </v-btn>
    </v-col>
    <v-col class="text-right">
      <v-btn
        color="primary"
        elevation="0"
        @click="setOnboardingStepsNavigation(onboardingStepsNavigation + 1)"
        :disabled="onboardingStepsNextEnabled"
      >
        Próximo
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'OnboardingStepsNavigation',

  computed: {
    ...mapGetters(['onboardingStepsNavigation', 'onboardingStepsNextEnabled']),
  },

  methods: {
    ...mapMutations(['setOnboardingStepsNavigation']),
  },
}
</script>
